import React, { useEffect, useState } from "react";
import Layout from "../Components/Layout/Layout";
import { Container, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import {
  downNewUserCSV,
  getNewUsers,
  updateIsContacted,
} from "../Redux/Actions/event";
import {
  capitalize,
  convertTo12HourFormat,
  formattedDate,
  formatYearAndMonth,
} from "../Utils/commonFiles";
import PaginationComponent from "../Components/Pagination";
import {
  createClient,
  deleteNewUsers,
  getClients,
} from "../Redux/Actions/auth";
import { toast } from "react-toastify";
import DeleteModal from "../Components/CommanModals/DeleteModal";
import DatePickerComponent from "../Components/DatePickerComponent";
import CreateClientModal from "../Components/CommanModals/CreateClientModal";

const Users = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedIds, setSelectedIds] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [createDateRange, setCreateDateRange] = useState(null);
  const [weddingDateRange, setWeddingDateRange] = useState(null);
  const [contactedFilter, setContactedFilter] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [checkedUsers, setCheckedUsers] = useState({});

  const newUsersLists = useSelector((e) => e.eventAuth.newUserLists);

  const totalEntries = newUsersLists?.total ?? 0;
  const entriesPerPage = 10;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);


  // ================================================================
  // const updateURLParams = (newPage, newSelectAll) => {
  //     const params = new URLSearchParams({
  //         page: newPage,
  //         selectAll: newSelectAll.toString(),
  //     });
  //     navigate(`/users?${params.toString()}`, { replace: true });
  // };

  const updateURLParams = (
    newPage,
    newSelectAll,
    createRange,
    weddingRange,
    isContactedVal
  ) => {
    const params = new URLSearchParams({
      page: newPage,
      selectAll: newSelectAll.toString(),
    });

    const finalCreateRange = createRange !== undefined ? createRange : createDateRange;
    const finalWeddingRange = weddingRange !== undefined ? weddingRange : weddingDateRange;
    const finalContacted = isContactedVal !== undefined ? isContactedVal : contactedFilter;

    if (finalCreateRange?.startDate && finalCreateRange?.endDate) {
      params.set("startDate", finalCreateRange.startDate);
      params.set("endDate", finalCreateRange.endDate);
    }

    if (finalWeddingRange?.from && finalWeddingRange?.to) {
      params.set("from", finalWeddingRange.from);
      params.set("to", finalWeddingRange.to);
    }

    if (finalContacted) {
      params.set("is_contacted", finalContacted);
    }

    const currentParams = new URLSearchParams(location.search);
    const searchQuery = currentParams.get("search");
    if (searchQuery) {
      params.set("search", searchQuery);
    }

    navigate(`/users?${params.toString()}`, { replace: true });
  };

  const initialize = async () => {
    try {

      const params = new URLSearchParams(location.search);
      const page = parseInt(params.get("page")) || 0;
      const selectAllParam = params.get("selectAll") === "true";
      const startDate = params.get("startDate") || null;
      const endDate = params.get("endDate") || null;
      const from = params.get("from") || null;
      const to = params.get("to") || null;
      const isContactedParam = params.get("is_contacted") || "";

      setCurrentPage(page);
      setSelectAll(selectAllParam);
      setContactedFilter(isContactedParam);

      if (startDate && endDate) {
        setCreateDateRange({ startDate, endDate });
      }
      if (from && to) {
        setWeddingDateRange({ from, to });
      }

      const searchQuery = params.get("search") || "";
      const queryParams = {
        page,
        limit: 10,
        ...(searchQuery && { search: searchQuery }),
        ...(startDate && endDate && { startDate, endDate }),
        ...(from && to && { from, to }),
        ...(isContactedParam && { is_contacted: isContactedParam }),
      };

      console.log('===query params', queryParams);

      dispatch(startstopLoading(true));
      dispatch(getNewUsers(queryParams)).then((res) => {
        dispatch(startstopLoading(false));
      });

    } catch (error) {

    }
  }


  useEffect(() => {
    initialize()
  }, [location.search, dispatch, location.pathname]);

  useEffect(() => {
    if (newUsersLists?.form?.length > 0) {
      if (selectAll) {
        const currentPageIds = newUsersLists.form.map((item) => item._id);
        setSelectedIds(currentPageIds);
      } else {
        setSelectedIds([]);
      }
    }
  }, [newUsersLists, selectAll]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    updateURLParams(page, selectAll, createDateRange, weddingDateRange);
  };

  const handleCheckboxChange = (id) => {
    let newSelectedIds;
    if (selectedIds.includes(id)) {
      newSelectedIds = selectedIds.filter((selectedId) => selectedId !== id);
      setSelectAll(false);
      updateURLParams(currentPage, false, createDateRange, weddingDateRange);
    } else {
      newSelectedIds = [...selectedIds, id];
      // Don't auto-check selectAll when all current page items are selected
    }
    setSelectedIds(newSelectedIds);
  };

  // const handleContactedChange = (e, item, index) => {
  //   if (e.target.checked) {
  //     setSelectedUsers((prev) => [...prev, item._id]);
  //   } else {
  //     setSelectedUsers((prev) => prev.filter((id) => id !== item._id));
  //   }
  //   // Example: dispatch an action
  //   dispatch(updateIsContacted({ isContacted: isChecked, userId: item?._id }));
  // };

  const handleContactedChange = (item) => {
    // setCheckedUsers((prev) => ({
    //   ...prev,
    //   [userId]: !prev[userId], // toggle the checkbox
    // }));

    // Optionally, dispatch your updateIsContacted action
    dispatch(updateIsContacted({ userId: item?._id, is_contacted: item?.is_contacted ? !item?.is_contacted : true })).then(() => {
      initialize()
    });
  };

  // const handleSelectAllChange = () => {
  //   const newSelectAll = !selectAll;
  //   let newSelectedIds = [];

  //   if (newSelectAll) {
  //     newSelectedIds = newUsersLists?.form?.map(item => item._id) || [];
  //   }
  //   setSelectAll(newSelectAll);
  //   setSelectedIds(newSelectedIds);
  //   updateURLParams(currentPage, newSelectAll);
  // };


  const handleSelectAllChange = () => {
    const newSelectAll = !selectAll;

    console.log('===selctAll', selectAll)
    console.log('===newSelectAll', newSelectAll)
    let newSelectedIds = [];


    if (newSelectAll) {
      newSelectedIds = newUsersLists?.form?.map(item => item._id) || [];
    }

    console.log('===newSelectedIds', newSelectedIds)
    setSelectAll(newSelectAll);
    setSelectedIds(newSelectedIds);
    updateURLParams(currentPage, newSelectAll, createDateRange, weddingDateRange);
  };

  console.log('===selectedIds', selectedIds)

  const handleDelete = () => {
    dispatch(deleteNewUsers({ ids: selectedIds })).then((res) => {
      if (res?.payload?.statusCode === 200) {
        updateURLParams(currentPage, false);
        dispatch(getNewUsers({ page: currentPage, limit: 10 }));
        toast.success("Deleted Successfully");
      } else {
        toast.error(res?.payload?.message);
      }
    });
    setShowDeleteModal(false);
    setSelectedIds([]);
    setSelectAll(false);
  };

  // ================================================================

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleDeleteButtonClick = () => {
    setShowDeleteModal(true);
  };

  const headers = [
    "Name",
    "Email",
    "Phone",
    "Created Date",
    "Wedding Date",
    "Wedding Month (Year)",
    "Wedding Venue",
    "Ceremony Time (If Known)",
    "Met At",
    "Anything I Need To Know",
  ];

  const downloadCSV = (filename, data) => {
    if (!data || !data.length) return;

    const csvRows = [];
    csvRows.push(headers.join(","));

    data.forEach((item) => {
      const values = headers.map((header) => {
        const value = item[header];
        return `"${value || ""}"`;
      });
      csvRows.push(values.join(","));
    });

    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${filename}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleExportButtonClick = async () => {
    let idsToDownload = [];

    if (selectAll) {
      const params = new URLSearchParams(location.search);
      const startDate = params.get("startDate") || null;
      const endDate = params.get("endDate") || null;
      const from = params.get("from") || null;
      const to = params.get("to") || null;
      const isContactedParam = params.get("is_contacted") || null;

      const queryParams = {
        page: 0,
        limit: 999999,
        ...(startDate && endDate && { startDate, endDate }),
        ...(from && to && { from, to }),
        ...(isContactedParam && { is_contacted: isContactedParam }),
      };

      try {
        const allUsersRes = await dispatch(getNewUsers(queryParams));
        idsToDownload = allUsersRes?.payload?.data?.form?.map(user => user._id) || [];
      } catch (error) {
        console.error("Error fetching all users:", error);
        toast.error("Failed to fetch all users for export");
        return;
      }
    } else {
      idsToDownload = selectedIds;
    }

    if (!idsToDownload.length) {
      toast.info("No users selected for download");
      return;
    }

    try {
      const res = await dispatch(downNewUserCSV({ ids: idsToDownload }));
      const formattedData = res?.payload?.data?.map((item) => {
        const formatField = (value) => value && value !== "N/A" && value !== "-" ? value : "-";

        function formatDateq(isoString) {
          if (!isoString || isoString === "N/A") return "-";
          const date = new Date(isoString);
          if (isNaN(date.getTime())) return "-";
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
        }

        function formatMonthYear(isoString) {
          if (!isoString || isoString === "N/A") return "-";
          const date = new Date(isoString);
          if (isNaN(date.getTime())) return "-";
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${month}/${year}`;
        }
        return {
          Name: formatField(item.fullName),
          Email: formatField(item.email),
          Phone: formatField(item.phoneNumber),
          "Created Date": formatDateq(item.createdAt),
          "Wedding Date": formatDateq(item.weddingDate),
          "Wedding Month (Year)": formatMonthYear(item.yearAndMonth),
          "Wedding Venue": formatField(item.weddingVenue),
          "Ceremony Time (If Known)": formatField(item.ceremonyTime),
          "Met At": item.meetVenue ? formatField(item.meetVenue.name) : "-",
          "Anything I Need To Know": formatField(item.additionalInformation),
        };
      }) || [];

      downloadCSV("NewUserCSV", formattedData);
      setSelectedIds([]);
      setSelectAll(false);
      // Refresh current page data after export
      initialize();
    } catch (error) {
      console.error("Error exporting CSV:", error);
    }
  };

  const handleCreateDateRangeChange = (range) => {
    setCreateDateRange(range);
    // Clear selections when filter changes
    setSelectedIds([]);
    setSelectAll(false);
    updateURLParams(currentPage, false, range, weddingDateRange);
  };

  const handleWeddingDateRangeChange = (range) => {
    setWeddingDateRange(range);
    // Clear selections when filter changes
    setSelectedIds([]);
    setSelectAll(false);
    updateURLParams(currentPage, false, createDateRange, range);
  };

  const handleContactedFilterChange = (value) => {
    setContactedFilter(value);
    // Clear selections when filter changes
    setSelectedIds([]);
    setSelectAll(false);
    updateURLParams(currentPage, false, createDateRange, weddingDateRange, value);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedClient(null);
  };

  const handleShow = (client) => {
    setSelectedClient(client);
    setShowModal(true);
  };

  const handleCreateClient = (clientData) => {
    dispatch(startstopLoading(true));

    dispatch(createClient(clientData))
      .then((res) => {
        dispatch(startstopLoading(false));

        if (res?.payload?.statusCode === 200) {
          const message = "Client Created Successfully";
          toast.success(message);
          dispatch(getClients({ page: currentPage, limit: 10 }));
          handleClose();
        } else {
          toast.error(res?.payload?.message || "Failed to process the request");
        }
      })
      .catch((error) => {
        console.error("Error in handleCreateClient:", error);
        toast.error("An error occurred. Please try again.");
      });
  };

  return (
    <Layout>
      <Container fluid>
        <div className="filter-design flex items-center justify-between">
          <h3>
            Registered Interest <span>({newUsersLists?.total ?? "0"})</span>
          </h3>

          <div className="d-flex gap-3">
            <DatePickerComponent
              onDateRangeChange={handleCreateDateRangeChange}
              type={"CreateDate"}
            />
            <DatePickerComponent
              onDateRangeChange={handleWeddingDateRangeChange}
              type={"WeddingDate"}
            />
            <select
              value={contactedFilter}
              onChange={(e) => handleContactedFilterChange(e.target.value)}
              className="form-control"
              style={{
                borderRadius: "6px",
                borderColor: "#d1d0d4",
                fontSize: "15px",
                height: "39px",
                fontWeight: "400",
                width: "180px",
                color: contactedFilter ? "#132027" : "#acaab1",
                cursor: "pointer",
                backgroundColor: "#fff"
              }}
            >
              <option value="">Contacted Status</option>
              <option value="true">Contacted</option>
              <option value="false">Not Contacted</option>
            </select>
          </div>
        </div>
        <div className="filters">
          <div className="select-td-delete">
            {selectedIds.length > 0 && (
              <div className="d-flex gap-2">
                <button
                  onClick={handleDeleteButtonClick}
                  className="delete-button"
                >
                  Delete
                </button>

                <button
                  onClick={handleExportButtonClick}
                  className="delete-button"
                >
                  Export CSV
                </button>
              </div>
            )}
          </div>
          <div className="inner-filter-field">
            <div class="table-responsive">
              <Table size="sm" className="table-cmn custom-th-colm">
                <thead>
                  <tr>
                    {/* <th>Contacted?</th> */}
                    <div className="remember-check mt-2 ms-2">
                      <input
                        type="checkbox"
                        className="red"
                        checked={selectAll}
                        onChange={handleSelectAllChange}
                      />
                    </div>
                    <th>Name</th>
                    {/* <th className="">
                      <div className="first-user">
                        <div className="remember-check">
              
                          Contacted?
                        </div>
                        <div className="user-profile">Name</div>
                      </div>
                    </th> */}
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Created Date</th>
                    <th>Wedding Date </th>
                    <th>Wedding Month, Year</th>
                    <th>Wedding Venue</th>
                    <th>Ceremony Time (if known)</th>
                    <th>Met At</th>
                    <th>Action</th>
                    <th>Contacted?</th>
                    <th>Anything I need to know?</th>
                  </tr>
                </thead>

                <tbody>
                  {newUsersLists?.form?.length > 0 &&
                    newUsersLists?.form?.map((item, i) => (
                      <tr key={item?._id || i}>
                        {/* <td className='m-5'>{(currentPage) * 10 + i + 1}</td> */}
                        <td>
                          <div className="remember-check">
                            <input
                              type="checkbox"
                              className="red"
                              id={`checkbox-${item?._id}`}
                              onChange={() => handleCheckboxChange(item?._id)}
                              checked={selectedIds.includes(item?._id)}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="first-user">
                            <div className="user-profile">
                              {capitalize(item?.fullName)}
                            </div>
                          </div>
                        </td>
                        <td>{item?.email}</td>
                        <td>{item?.phoneNumber || "N/A"}</td>
                        <td>{formattedDate(item?.createdAt)}</td>
                        <td>
                          {item?.weddingDate
                            ? formattedDate(item?.weddingDate)
                            : "-"}
                        </td>
                        <td>{formatYearAndMonth(item?.yearAndMonth) || "-"}</td>
                        <td>{capitalize(item?.weddingVenue) || "-"}</td>
                        <td>
                          {convertTo12HourFormat(item?.ceremonyTime) || "-"}
                        </td>
                        <td>{item?.meetVenue?.name || "-"}</td>
                        <td>
                          {!item?.isClient ? (
                            <button
                              onClick={() => handleShow(item)}
                              className="convert-btn"
                            >
                              Convert to Client
                            </button>
                          ) : (
                            <>Added as Client</>
                          )}
                        </td>
                        <td>
                          <div className="remember-check ms-4">
                            <input
                              type="checkbox"
                              className="red"
                              checked={item?.is_contacted || false}
                              onChange={(e) =>
                                handleContactedChange(item)
                              }
                            />
                          </div>
                        </td>
                        <td className="registered-interest-info">
                          {item?.additionalInformation || "-"}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              {newUsersLists?.total > 1 && (
                <PaginationComponent
                  currentPage={parseInt(
                    new URLSearchParams(location.search).get("page") || "0"
                  )}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  totalEntries={totalEntries}
                  entriesPerPage={entriesPerPage}
                />
              )}
            </div>
          </div>
        </div>

        <DeleteModal
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDelete}
          name={"Users"}
        />

        <CreateClientModal
          show={showModal}
          handleClose={handleClose}
          handleCreateClient={handleCreateClient}
          selectedClient={selectedClient}
          type={"newuser"}
        />
      </Container>
    </Layout>
  );
};

export default Users;
